import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../redux/CakeArray/actions";

export default function WeightList({ option, className, handleSelectButton, handleRemoveButton, disabledButton, show, cakeWeightList, OrderedWeight }) {

    const [list, setList] = useState([]);
    const [newWeight, setNewWeight] = useState('');
    const [message, setMessage] = useState('');

    const dispatch = useDispatch();

    //get status for add new weight
    const { AddNewWeightStatus } = useSelector(state => state.CakeArrayReducer);

    useEffect(() => {
        if (option === undefined) {
            setList([]);
        } else {
            setList(option);
        };
    }, [option]);

    //add new weight functionality
    const handleAddNew = () => {
        setMessage('');
        if (newWeight) {
            const newList = list.filter(val => {
                if (val.Weight === newWeight) {
                    return val;
                } else {
                    return null;
                }
            });
            if (newList.length === 0) {
                dispatch({ type: actions.ADD_NEW_WEIGHT, payload: newWeight });
            }
        } else {
            setMessage('*required');
            setTimeout(() => setMessage(''), 5000);
        }
    };

    //validate add new weight status
    useEffect(() => {
        if (AddNewWeightStatus !== undefined) {
            if (AddNewWeightStatus.statusCode === 200) {
                dispatch({ type: actions.GET_WEIGHT_LIST });
                setNewWeight('')
            }
        };
    }, [AddNewWeightStatus, dispatch]);

    return (
        <div>
            <label htmlFor="validationCustom22" className='font-weight-bold'>Add Weight <span className='text-danger'>*</span></label>
            <div className="input-group">
                <div className='display-flex w-100'>
                    <input type="text" className="form-control" value={newWeight} onChange={(e) => setNewWeight(e.target.value)} />
                    <button className='add-button rounded' onClick={handleAddNew}>add</button>
                </div>
            </div>
            <div className="scrollable-list">
                {show ?
                    <>
                        {list.map((value, i) =>
                            <div className="display-flex mb-2 list-main" key={i}>
                                {!(disabledButton === i) ?
                                    <>
                                        <div className={className}>{value.Weight}</div>
                                        <button
                                            className='add-button'
                                            disabled={!OrderedWeight ? true : (parseFloat(value.Weight.match(/([0-9.]+)(?![0-9.])|([a-z]+)(?![a-z])/gi)[0]) >= parseFloat(OrderedWeight?.match(/([0-9.]+)(?![0-9.])|([a-z]+)(?![a-z])/gi)[0])) ? false : true}
                                            value={value.Weight}
                                            onClick={() => handleSelectButton(value, i)}
                                        > + </button>
                                    </> :
                                    <>
                                        <button className='mr-1 minus-button' value={value.Weight} onClick={() => handleRemoveButton(i)}> - </button>
                                        <div className={className}> {value.Weight}</div>
                                    </>}
                            </div>
                        )}
                    </> :
                    <div className="text-center mt-2">No Records Found</div>
                }
            </div>
            <p className="text-danger mt-1">{message}</p>
            <div className="list-array" > {cakeWeightList} </div>
        </div>
    )
};